// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';

const schema = {
  $id: '/download-calendar-file-request-schema',
  type: 'object',
  required: ['id', 'language', 'eventPartyRoleId'],
  properties: {
    id: {
      type: 'string',
      format: 'uuid',
    },
    language: {
      type: 'string',
    },
    eventPartyRoleId: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
